module.exports = __webpack_public_path__ + "img/1.d44fdc0d.jpg";